<template>
  <div class="hours-grid">
    <div
      class="hour-cell__container"
      v-for="cell in cells"
      @click="emit('update:modelValue', cell.hour)"
    >
      <slot name="cell" :cell="cell">
        <div
          :class="['hour-cell', { 'is-selected': modelValue === cell.hour }]"
        >
          {{ cell.text }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { generateHourItems } from "../../generators";

const emit = defineEmits<{
  /**Событие выбора часов */
  (e: "update:modelValue", value: number): void;
}>();

const props = defineProps({
  /**Выбранные часы */
  modelValue: { type: Number },
});

const cells = generateHourItems();
</script>

<style lang="scss" scoped>
.hours-grid {
  display: grid;
  width: var(--tir-pm-datepicker__hours-grid-w);
  grid-template-columns: repeat(6, var(--tir-pm-datepicker__hour-cell-size));
  justify-content: space-between;

  .hour-cell {
    width: var(--tir-pm-datepicker__hour-cell-size);
    height: var(--tir-pm-datepicker__hour-cell-size);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--tir-pm-datepicker__cell-fs);
    font-weight: var(--tir-pm-datepicker__cell-fw);
    border-radius: var(--tir-pm-datepicker__cell-br);
    color: var(--tir-pm-datepicker__cell-color);

    &__container {
      width: var(--tir-pm-datepicker__hour-cell-size);
      height: var(--tir-pm-datepicker__hour-cell-size);
      cursor: pointer;
    }

    &:hover {
      background-color: var(--tir-pm-datepicker__cell-hover-bg);
    }
    &.is-selected {
      color: var(--tir-pm-datepicker__cell-selected-color);
      background-color: var(--tir-pm-datepicker__cell-selected-bg);

      &:hover {
        background-color: var(--tir-pm-datepicker__cell-hover-selected-bg);
      }
    }
  }
}
</style>
